import {ENDPOINT_ADMIN_EARNED_MONEYS_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const loopMap = require('mn-utils/loopMap');
const Emitter = require('mn-utils/Emitter');
const {
  apiRequestAdmin,
} = require('../ws');


const earnedMoney$ = new Emitter(loopMap(100, (i) => ({
  id: '' + i + '8e80acfa-0448-4229-8562-e1887e5a0109',
  created_at: '2020-12-22T10:44:32.664511+00:00',
  username: 'pd@lunu.io',
  cc_code: 'ETH',
  fiat_value: 0.000540359739,
  fiat_code: 'EUR',
})));

export function apiAdminEarnedMoneyList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  if (process.env.MOCK) {
    const items = earnedMoney$.getValue();
    return CancelablePromise.delay(500, {
      list: items.slice(offset, offset + limit),
      count: items.length,
    });
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_EARNED_MONEYS_LIST, {
    ...params,
    offset,
    limit,
  });
}
